import { interval as observableInterval, Subscription, Observable, forkJoin, throwError } from 'rxjs';

import { finalize, map, tap, switchMap, catchError } from 'rxjs/operators';
import { PlycaDataService } from '../../../services/plyca.service';
import { TaskHandler } from '../../tasks/TaskHandler';
import {
  TaskDTO,
  FileDetailsDTO,
  SignatureDTO,
  DocumentDTO,
  DocumentFileTypeDTO,
  ActionTypeDTO,
  I18nData,
  getSimpleIdentifier,
  DocumentVersionIdDTO,
  DocumentVersionDTO,
  SignatureCommentsListDTO,
  SignatureCommentDTO,
  WorkStateTypeDTO,
  SignatureValidationCode
} from '../../api/plyca-dtos';
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterContentInit,
  Input,
  SimpleChanges,
  OnChanges
} from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { DocumentService } from '../document.service';
import { ServiceLocator } from './../../ServiceLocator';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { UserService } from '../../user.service';
import { Configuration } from '../../../app/conf/app.constants';
import { TokenService } from '../../token.service';

import { SignatureService } from '../../../services/signature.service';
import { filePDFViewerComponent } from '../filePDFViewer/filePDFViewer.component';

import { TranslateService } from '@ngx-translate/core';
import {
  WaitLoadingService,
  LoadingInfo
} from '../../components/common/waitLoading/wait-loading.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import {
  HelpService,
  HelpType
} from '../../components/common/help/help.service';
import { generateRandomIdentifier } from '../../ui.service';
import { SelectItem } from 'primeng-lts/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { AppConfiguration } from '../../conf/app.configuration';
import { PropertyService } from '../../properties/property.service';
import { documentsComponent } from '../documents.component';
import { LongTextDTOModal, LongTextEditorComponent } from '../../components/forms/longTextEditor.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import {
  SignatureProvider,
  SignatureProviderType,
  SignatureRequest, SignatureResponse, SignatureStatus
} from '../../../services/signature/signature.objects';
import { SignatureUtils } from '../../../services/signature.utils';


const MAX_TASKDETAIL_RETRIES = 3;
const TASKDETAIL_RETRY_INTERVAL = 10000;

@Component({
  selector: 'documentViewer',
  templateUrl: 'documentViewer.template.html',
  providers: [DialogService]
})
export class documentViewerComponent extends TaskHandler implements OnInit, AfterContentInit, OnDestroy, OnChanges {
  public docLoaded = false;
  private showExpanded = false;
  private showFloatInfo = false;

  protected userService: UserService;
  public route: Router;

  @Input()
  documentIdParam: string;

  documentId = 'Sin Información';
  document: DocumentDTO;
  documentIndex: number;
  private documentVersionId: number;
  documentVersion: DocumentVersionDTO;
  public windowHash: string;
  tagsParent: string[];
  private signingCall = false;
  private isSignActionAvailable = false;
  private isSignModuleAvailable: Map<SignatureProviderType, boolean>;
  private isRejectActionAvailable = false;

  public currentFile: FileDetailsDTO;
  private ca_files: Array<FileDetailsDTO>;
  private oe_files: Array<FileDetailsDTO>;
  private usr_files: Array<FileDetailsDTO>;
  private sys_files: Array<FileDetailsDTO>;

  protected comments: Array<SelectItem> = [];
  protected selectedComment: SignatureCommentDTO;
  protected comment = '';

  private signatureSubscription: Subscription;

  private retryObservable: Observable<any>;
  private retrySubscription: Subscription;

  private signatures = new Array<SignatureResponse>();
  protected signaturesPlainList = new Array<SignatureResponse>();

  documentService: DocumentService;
  location: Location;
  private numberOfTaskDetailInvocation = 1;

  private filePDFViewerComponent: filePDFViewerComponent;

  protected maxLengthCommentSign: number;

  public fileHtmlContent: SafeHtml;
  protected htmlviewerActive = false;
  protected systemFilesVisible: string;

  private signatureService: SignatureService;

  public plycaService: PlycaDataService;
  public tokenService: TokenService;

  private translate: TranslateService;
  private headerService: HeaderActionsService;

  private configuration: Configuration;

  public adaptationAymadEnabled = false;
  private enabledSignatureProviders: SignatureProvider[];

  @ViewChild(filePDFViewerComponent)
  set content(content: filePDFViewerComponent) {
    this.filePDFViewerComponent = content;
    if (
      this.filePDFViewerComponent &&
      this.filePDFViewerComponent.propsObservable instanceof Observable
    ) {
      this.subscribe((<Observable<any>>this.filePDFViewerComponent.propsObservable),
        (props: any) => {
          this.showExpanded = props.showExpanded;
          this.showFloatInfo = props.showFloatInfo;
        }
      );
    } else {
      this.showExpanded = false;
      this.showFloatInfo = false;
    }
  }

  constructor(
    private elem: ElementRef,
    protected dialogConfig: DynamicDialogConfig,
    activatedRoute: ActivatedRoute,
    private helpService: HelpService,
    protected dialogRef: DynamicDialogRef,
    private appConfig: AppConfiguration,
    private propertyService: PropertyService,
    private sanitizer: DomSanitizer,
    private plycaErrorHandler: PlycaErrorHandler,
    private signatureUtils: SignatureUtils
  ) {

    super();
    this.signatureService = ServiceLocator.injector.get(SignatureService);

    // carga de la información de la ayuda
    // this.helpService.showContextHelp(HelpType.VER_DOCUMENTO);

    this.adaptationAymadEnabled = appConfig.getValue('cliente') === 'AYMAD';

    this.plycaService = ServiceLocator.injector.get(PlycaDataService);
    this.tokenService = ServiceLocator.injector.get(TokenService);
    this.translate = ServiceLocator.injector.get(TranslateService);

    this.headerService = ServiceLocator.injector.get(HeaderActionsService);
    this.configuration = ServiceLocator.injector.get(Configuration);
    this.waitService = ServiceLocator.injector.get(WaitLoadingService);

    this.waitService.startWaiting();
    this.userService = ServiceLocator.injector.get(UserService);
    this.documentService = ServiceLocator.injector.get(DocumentService);
    this.location = ServiceLocator.injector.get(Location);
    this.route = ServiceLocator.injector.get(Router);
    if (this.dialogConfig && this.dialogConfig.data) {
      this.documentId = this.dialogConfig.data.id;
      this.documentVersionId = this.dialogConfig.data.version;
    } else {
      this.subscribe(activatedRoute.params.pipe(finalize(() => { })), (params) => {
        this.documentId = params['id'];
        this.documentVersionId = params['version'];
      });
    }

    this.htmlviewerActive = this.appConfig.getValue('htmlviewer.active');
    this.systemFilesVisible = this.appConfig.getValue('documentViewer.systemFiles.visible.defaultProfiles');
    this.isSignModuleAvailable = new Map();
    this.enabledSignatureProviders = this.signatureUtils.getSignatureProviders().filter(provider =>
      this.signatureService.isSignatureProviderEnabled(provider.type)
    );
  }

  private documentHasAction(document: DocumentDTO, actionType: string): boolean {
    let hasAction = false;
    if (document?.availableActions) {
      let action = document.availableActions.actions.filter(
        x => x.identifier === actionType
      );
      hasAction = action.length > 0;
    }
    return hasAction;
  }

  private signModuleAvailable(type: SignatureProviderType) {
    return this.isSignModuleAvailable.get(type);
  }

  private isTaskReloadRequired(): boolean {
    return (this.task.work?.documents && this.task.work?.documents[this.documentIndex]?.type !== DocumentFileTypeDTO.Original);
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes?.documentIdParam && !changes.documentIdParam.firstChange) {
      this.documentId = this.documentIdParam;
      // Borramos las variables para que se vuelvan a cargar con el nuevo documento
      this.initFileInterface();
      this.loadDocument();
    }
  }

  ngOnInit(): void {
    console.log('documentViewerComponent ngOnInit');
    if (this.documentIdParam) {
      this.documentId = this.documentIdParam;
    }

    // carga de la información de la ayuda
    // No se puede cargar en el constructor por que this.task no tiene valor al abrirse la instacia desde basetask


    this.subscribe(this.helpService.getStoreTagsObservable().pipe(
      switchMap(
        (storedHelpTags) => {
          this.tagsParent = [];
          // Se guarda la ayuda previa de tarea o de la modal que abre esta
          this.tagsParent = storedHelpTags;
          let helpTags = this.tagsParent;

          if (this.task) {
            helpTags.push(HelpType.VER_DOCUMENTO);
            return this.helpService.showContextHelpObservable(helpTags)
          } else {

            return this.helpService.showContextHelpObservable(HelpType.VER_DOCUMENTO)
          }

        }
      )));

    if (this.modalWindowHash) {
      this.windowHash = this.modalWindowHash;
    } else if (this.dialogConfig && this.dialogConfig.data) {
      this.windowHash = generateRandomIdentifier();
    }
    this.subscribe(this.signatureService.getSignatures(), (signature: SignatureResponse) => {
      this.addSignature(signature);
    });
    this.subscribe(this.waitService.getLoadingObservable(), (loadingInfo: LoadingInfo) => {
      if (loadingInfo && !loadingInfo.loading) {
        this.stopRetrySubscription();
      }
    });
    // si llega tarea hay que coger el id del documento del work
    if (this.task) {
      if (this.enabledSignatureProviders) {
        this.enabledSignatureProviders.forEach(provider => {
          this.signatureService.check(
            () => this.isSignModuleAvailable.set(provider.type, true),
            () => {
              this.isSignModuleAvailable.set(provider.type, false);
              this.uiService.showMessage(
                this.translateService.instant('Signature.Error.Connection', {
                  nombreApp: this.translateService.instant(provider.config?.btnName)
                }),
                'Error', 'errorStyle',
                'General.accept');
            },
            provider.type
          );
        });
      }
      this.signingCall = true;
      this.retryObservable = observableInterval(TASKDETAIL_RETRY_INTERVAL).pipe(
        map(n => {
          console.warn('Actualizando datos de la tarea');
          this.taskService
            .getTaskWithActions(this.task.identifier)
            .pipe(finalize(() => this.numberOfTaskDetailInvocation++))
            .subscribe((updatedTask: TaskDTO) => {
              this.task = updatedTask;
              this.ngOnInit();
            });
        })
      );
      // ir al primer documento sin firma
      let documentIndex = this.getNextDocumentToSignIndex();
      this.documentIndex = documentIndex;
      this.loadTaskDocument(true);
    } else {
      this.loadDocument();
    }
  }

  /**
   * Devuelve el indice del primer documento pendiente de firma a partir del indice indicado
   *
   * En caso de que no haya uno pendiente a partir del indice indicado, devolverá el último disponible
   *
   * @param startIndex
   * @returns
   */
  private getNextDocumentToSignIndex(startIndex = -1): number {
    let nextDocumentToSign = -1;
    if (this.task.work?.documents) {
      let lastUnsignedDocument: number;
      let taskDocument: DocumentDTO;
      for (let i = 0; i < this.task.work.documents.length && nextDocumentToSign === -1; i++) {
        taskDocument = this.task.work?.documents[i];
        if (this.documentHasAction(taskDocument, ActionTypeDTO.DOCUMENT_SIGN)) {
          lastUnsignedDocument = i;
          if (i > startIndex) {
            nextDocumentToSign = i;
          }
        }
      }
      if (nextDocumentToSign === -1) {
        if (lastUnsignedDocument > -1) {
          nextDocumentToSign = lastUnsignedDocument;
        } else {
          nextDocumentToSign = 0;
        }
      }
    }
    return nextDocumentToSign;
  }

  private stopRetrySubscription() {
    if (this.retrySubscription != null && !this.retrySubscription.closed) {
      this.unregisterSubscription(this.retrySubscription);
      this.validaCierreVentana = false;
      // this.loading.next(new LoadingInfo(false));
      this.waitService.cancelWaiting();
      this.uiService.showMessage(this.translate.instant('DocumentView.error.OE.TimeOut'), this.translate.instant('General.error'));
      // this.route.navigate(['tasks']);
      this.salir();
    }
  }

  salir() {
    // invocado al firmar o devolver
    if (this.dialogConfig && this.dialogConfig.data) {
      this.waitService.cancelWaiting();
      this.dialogRef.close();
    } else {
      super.salir();
    }
  }


  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.headerService.clearWindowActions(this.windowHash);
    if (this.windowHash) {
      // Para devolver la ayuda cuando se abre como modal
      this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
        finalize(() => {
          this.stopRetrySubscription();


          this.dialogConfig = null;
          this.dialogRef = null;
          this.dialogService = null;
        }
        )));
    } else {
      this.stopRetrySubscription();

      this.dialogConfig = null;
      this.dialogRef = null;
      this.dialogService = null;
    }
  }


  getClassDocExpanded() {
    return this.showExpanded ? 'col-12' : 'col-12 col-md-9';
  }
  getStyleInfo() {
    return this.showExpanded ? 'd-none' : 'd-none col-md-3 d-md-block';
  }
  /*
  getStyleInfo() {
    if (this.showExpanded && this.showFloatInfo) {
      return 'd-block col-md-3';
    } else if (this.showExpanded && !this.showFloatInfo) {
      return 'd-none';
    } else {
      return '';
    }
  }*/

  ngAfterContentInit(): void {


  }

  loadDocument(): void {
    console.log('loadDocument...');
    let documentObs: Observable<DocumentDTO>;

    let params: any;
    params = {};
    if (!this.documentId) {
      this.uiService.showMessage(this.translate.instant('DocumentView.error.NoDocument'), this.translate.instant('General.error'));
      return;
    }

    if (this.documentVersionId) {
      params.expand = 'expansionSet:DETAIL_WITHOUTFILES,hasRelatedDocuments';
      documentObs = forkJoin(
        this.plycaService.get<DocumentDTO>(this.configuration.DOCUMENTS_SERVICE_URL, this.documentId, params),
        this.plycaService.get<DocumentVersionDTO>(
          this.configuration.DOCUMENTVERSION_SERVICE_URL.replace('{docId}', this.documentId)
          , '' + this.documentVersionId)
      ).pipe(
        tap((result: any) => this.documentVersion = result[1]),
        map((result: any) => result[0])
      );
    } else {
      params.expand = 'expansionSet:DETAIL_WITHFILESUPDATE,hasRelatedDocuments';
      documentObs = this.plycaService.get<DocumentDTO>(this.configuration.DOCUMENTS_SERVICE_URL, this.documentId, params).pipe(
        tap((document: DocumentDTO) => this.documentVersion = document.currentVersion
        ),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })
      );
    }

    if (this.task && this.isSigningCall()) {
      this.subscribe(this.plycaService.get<SignatureCommentsListDTO>(
        this.configuration.SIGNATURE_COMMENTS_SERVICE_URL.replace('{taskId}', this.task.identifier), ''),
        (_commentsDTO) => {
          if (_commentsDTO.suggestedComments) {
            this.comments = _commentsDTO.suggestedComments.map(comment => {
              return {
                'label': comment.comment,
                'value': comment
              };
            });
            if (this.comments) {
              this.selectedComment = this.comments[0].value;
              if (this.selectedComment) {
                this.comment = this.selectedComment.comment;
              }
            }
          }
        });
    }
    this.waitService.startWaiting(this.translate.instant('DocumentView.wait.load'));
    // obtener documento
    this.subscribe(documentObs.pipe(
      finalize(() => {
        this.docLoaded = true;
        this.waitService.cancelWaiting();
      })
    ), (param: DocumentDTO) => {
      this.document = param;
      console.log('all_files', this.document);
      console.log('all_files', this.documentVersion.files);
      this.createActions();
      this.ca_files = this.documentService.getTypeDocumentVersion(
        DocumentFileTypeDTO.CertifiedCopy,
        this.documentVersion
      );
      console.log('ca_files', this.ca_files);
      if (!this.currentFile && this.ca_files) {
        this.currentFile = this.ca_files[0];
      }


      this.signatures = [];

      this.oe_files = this.documentService.getTypeDocumentVersion(
        DocumentFileTypeDTO.Original,
        this.documentVersion
      );

      console.log('oe_files', this.oe_files);
      if (!this.currentFile && this.oe_files) {
        this.currentFile = this.oe_files[0];
      }
      this.usr_files = this.documentService.getTypeDocumentVersion(
        DocumentFileTypeDTO.Draft,
        this.documentVersion
      );
      console.log('usr_files', this.usr_files);
      if (!this.currentFile && this.usr_files) {
        this.currentFile = this.usr_files[0];
      }
      this.sys_files = this.documentService.getTypeDocumentVersion(
        DocumentFileTypeDTO.System,
        this.documentVersion
      );

      console.log('sys_files', this.sys_files);
      this.sortsys_file();
      if (!this.currentFile && this.sys_files) {
        this.currentFile = this.sys_files[0];
      }
      console.log('currentFile', this.currentFile);
      console.log('user', this.document.user);
      if (this.currentFile && this.currentFile.signatures) {
        this.signaturesPlainList = [];
        this.toPlainList(this.currentFile.signatures);
      }

      // El archivo a visualizar depende del tipo de documento
      this.checkFileToShow();

      // Cargar la vista HTML
      if (this.isFileHtml(this.currentFile)) {
        this.getFileContent(this.currentFile);
      }

      // numero máximo de caracteres del comentario de firma
      this.subscribe(this.propertyService.getProperty('FIRMA_TAMANIO_COMENTARIO', '400'), (value: string) => {
        this.maxLengthCommentSign = +value;
      });


    });
  }

  sortsys_file(): void {
    this.sys_files.sort((a, b) => {
      const aEndsWithXML = a.name.toLowerCase().endsWith('.html');
      const bEndsWithXML = b.name.toLowerCase().endsWith('.html');

      if (aEndsWithXML && !bEndsWithXML) {
        return -1;// Devuelve -1 para indicar que a debe preceder a b en el orden.
      } else if (!aEndsWithXML && bEndsWithXML) {
        return 1; // Devuelve 1 para indicar que a debe seguir a b en el orden.
      } else {
        return 0; //Devuelve 0 para indicar que no hay cambio en el orden relativo de a y b.
      }
    });
  }

  checkFileToShow() {
    // En los documentos para los que se debe visualizar el html que se genera (ofertas, por ejemplo)
    // incluimos el html dentro de los OE y lo hacemos currentFile
    let docName = this.document?.entity?.documentClass?.abbreviation;
    let htmlDocuments = this.propertyService.instant('FraFirmaVerDocumento.nombresDocumentosVerSiempreHTML', '')
    if (docName && htmlDocuments.length > 0) {
      let htmlFile;
      if (this.sys_files) {
        for (let i = 0; i < this.sys_files.length; ++i) {
          let fileI = this.sys_files[i];
          if (fileI.name && fileI.name.toLowerCase().endsWith('html')) {
            htmlFile = fileI;
          }
        }
      }
      let documents = htmlDocuments.split(';');
      let showHtml = documents.find(doc => docName === doc);
      // Ponemos como original electronico el html
      if (htmlFile && (showHtml || !this.currentFile)) {
        this.oe_files.splice(0, 0, htmlFile);
        this.currentFile = htmlFile;
      }
    }
  }

  printFile(fileItem: FileDetailsDTO) {
    this.documentService.printFile(fileItem);
  }
  downloadFile(fileItem: FileDetailsDTO) {
    this.documentService.downloadEmbedded(fileItem);
  }

  getFileContent(fileItem: FileDetailsDTO) {
    this.subscribe(this.plycaService.getDocumentContentAsText(fileItem),
      text => {
        text = text
          .replace(/src\s*=\s*"images\//gm, 'src=\"assets/img/docsHtml/')
          .replace('<img src=\"assets/img/docsHtml/escudo.gif\">", "<img src=\"assets/img/logo.png\">');
        let text2 = text.match(/<body[^>]*>((.|[\n\r])*)<\/body>/im);
        this.fileHtmlContent = this.sanitizer.bypassSecurityTrustHtml(text2[1]);
      });
  }

  isFileHtml(file: FileDetailsDTO): boolean {
    if (file) {
      let name: string = file.name;
      if (!name) {
        name = '';
      }
      return (
        file &&
        name.toUpperCase().substring(name.lastIndexOf('.') + 1) === 'HTML'
      );
    }
    return false;
  }

  isFilePdf(file: FileDetailsDTO): boolean {
    if (file) {
      let name: string = file.name;
      if (!name) {
        name = '';
      }
      return (
        file &&
        name.toUpperCase().substring(name.lastIndexOf('.') + 1) === 'PDF'
      );
    }
    return false;
  }

  isPdf(): boolean {
    return this.isFilePdf(this.currentFile);
  }

  isLoadCurrentFile(): boolean {
    return this.currentFile != null;
  }

  loadFile(file: FileDetailsDTO) {
    if (file && file.links) {
      this.currentFile = file;
      if (this.isFilePdf(file)) {
        this.filePDFViewerComponent.loadDocumentItem(this.currentFile);
      }
      let url = file.download.links[0].href;
      console.log(file.download.links[0].href);
      console.log('fin');

      // recargar lista de firmas del fichero
      if (this.currentFile.signatures) {
        this.signaturesPlainList = [];
        this.toPlainList(this.currentFile.signatures);
      }
      // Cargar la vista HTML
      if (this.isFileHtml(this.currentFile)) {
        this.getFileContent(this.currentFile);
      }
    }
  }

  validateSignDocument(signature: SignatureDTO, fileItem: FileDetailsDTO) {
    if (!signature.handWritten) {
      console.log('Método validateSignDocument');
      this.documentService.validateSignDocument(signature, fileItem);
    }
  }

  viewHistory(documentId: string) {
    console.log('Método viewHistory');
    this.documentService.viewHistory(this.document);
  }

  // public isLoading(): Observable<LoadingInfo | boolean> {
  //   return this.loadingObservable;
  // }

  public isDocLoaded(): boolean {
    return this.docLoaded;
  }

  closeOK() {
    this.isTaskUnlocked = true;
    //    this.location.back();
    // this.route.navigate(['tasks']);
    this.salir();
  }

  isSigningCall(): boolean {
    return this.signingCall;
  }

  private rejectDocument(): void {
    this.waitService.startWaiting();
    let rejectAction = this.task.work.documents[this.documentIndex].availableActions.actions
      .find(action => action.identifier === ActionTypeDTO.DOCUMENT_REJECT);
    this.setDocumentTaskReference(this.document);
    // Solicitar comentario de devolución
    let context = new LongTextDTOModal('', '', false);
    let config: DynamicDialogConfig = {
      header: this.translate.instant('DocumentView.refuseTitle'),
      width: '65%',
      style: { overflow: 'hidden', 'max-height': '80%' },

      styleClass: 'formEdition'
    };

    context.label = '';
    context.text = '';

    context.maxLong = 600; // this.maxLengthCommentSign;
    config['context'] = context;

    const ref = this.dialogService.open(LongTextEditorComponent, config);
    this.subscribe(ref.onClose, result => {
      if (result) {
        this.document.comment = result;
      }
      this.confirmationService.confirm({
        message: this.translate.instant('DocumentView.refuseConfirm'),
        accept: () => {
          this.subscribe(this.plycaService.simpleUpdate(rejectAction.links[0].href, this.document).pipe(
            catchError((error: any) => {
              this.errorHandler.showServerError(error);
              return throwError(error);
            }),
            switchMap(() => this.updateViewAfterSignOrReject('REJECT'))
          ));
        }
      });


    });

    // this.openModal(ActionTypeDTO.DOCUMENT_REJECT);
  }

  private updateViewAfterSignOrReject(SignOrReject = ''): Observable<any> {
    return this.taskService.saveWork(this.task, true).pipe(
      tap((updatedTask: TaskDTO) => {
        this.task = updatedTask;
        //
        if (this.task?.availableActions?.actions
          && this.task.availableActions.actions.find(action => action.identifier === ActionTypeDTO.TASK_DISPATCH)) {
          // no quedan documentos pendientes -> despachar
          this.dispatch(/*signature*/ SignOrReject);
        } else {
          this.documentIndex = this.getNextDocumentToSignIndex(this.documentIndex);
          this.loadTaskDocument();
        }
      })
    )
  }

  signDocument(type: SignatureProviderType) {
    console.log('firmando documento');
    if (this.oe_files.length > 0) {
      this.waitService.startWaiting();
      // this.loading.next(new LoadingInfo(true));
      console.log('this.oe_files.length', this.oe_files.length);
      this.oe_files.forEach((file2Sign: FileDetailsDTO) => {
        console.log('firmando fichero:' + file2Sign.name, this.comment);
        const request = new SignatureRequest();
        request.file = file2Sign;
        request.documentClass = this.document.entity.documentClass;
        request.comment = this.comment;
        request.provider = type;
        this.signatureService.sign(request);
      });
    }
  }


  private addSignature(signature: SignatureResponse) {
    if (signature.status !== SignatureStatus.CANCELLED) {
      if (signature.signatureStatus !== SignatureValidationCode.OK) {
        console.error('addSignature: Error en la firma');
        this.waitService.cancelWaiting();
        const invalidSignature = this.signatureUtils.getFirstSignatureWithVerificationEror(signature.file.signatures);
        if (invalidSignature) {
          this.signatureService.showSignatureValidationDetails(
            invalidSignature,
            signature.request.file
          );
        } else {
          this.subscribe(this.uiService.showMessage(signature.errorMessage).onClose,
            (result) => {
              if (result) {
                console.error('Se cierra');
                this.signatures = new Array<SignatureResponse>();
              }
            });
        }

      } else if (signature && this.isDocumentSignature(signature)) {
        console.log('addSignature: Firma correcta', this.signatures, this.oe_files);
        this.signatures.push(signature);
        if (this.signatures.length === this.oe_files.length) {
          if (this.isSignProcessValid()) {
            // procesar las firmas
            this.processSignatures();
            // actualizar documentos tipo oe en tarea
            let document = this.task.work?.documents[this.documentIndex];
            document.currentVersion.files = document.currentVersion.files.filter(
              (file: FileDetailsDTO) =>
                file.fileType !== DocumentFileTypeDTO.Original
            );
            this.oe_files.forEach((signedOE: FileDetailsDTO) =>
              document.currentVersion.files.push(signedOE)
            );
            // actualizamos el documento
            this.setDocumentTaskReference(document);
            this.subscribe(this.plycaService.update<DocumentDTO>(this.configuration.DOCUMENTS_SERVICE_URL, document).pipe(
              catchError((error: any) => {
                this.errorHandler.showServerError(error);
                return throwError(error);
              }),
              switchMap(() => this.updateViewAfterSignOrReject(/*signature*/))));
          } else {
            this.waitService.cancelWaiting();
            console.log('Errores en la firma');
          }
        } else {
          console.log('Existen más originales electrónicos a firmar. Esperando a firmar el resto de originales electrónicos...');
        }
      } else {
        console.log(
          'Ignorando la firma:',
          signature,
          '. No se corresponde con un fichero del documento:',
          this.document.name
        );
        this.waitService.cancelWaiting();
      }
    } else {
      console.log('Firma cancelada', signature);
      this.waitService.cancelWaiting();
    }
  }

  private setDocumentTaskReference(document: DocumentDTO) {
    document.task = {} as TaskDTO;
    document.task.identifier = this.task.identifier;
  }

  private dispatch(SignOrReject = ''): void {
    this.waitService.startWaiting();
    this.subscribe(this.taskService.dispatchTask(this.task).pipe(
      finalize(() => this.waitService.cancelWaiting())),
      () => {
        let messageText = 'DocumentFile.signedAndDispached';
        if (SignOrReject !== undefined && SignOrReject === 'REJECT') {
          messageText = 'DocumentFile.rejectAndDispached';
        }
        let i18nText = new I18nData(
          messageText,
          {
            documento: this.document.name,
            expediente: this.task.division.project
              .contractFolderId
          }
        );
        this.uiService.showSuccess(
          i18nText,
          this.translate.instant('General.info'),
          'success'
        );
        this.closeOK();
      },
      (err: any) => {
        this.loadTaskDocument();
        this.errorHandler.showServerError(err);
      }
    );
  }

  private isDocumentSignature(signature: SignatureResponse) {
    return this.oe_files.find(
      (originalFile: FileDetailsDTO) =>
        originalFile.identifier === signature.request.file.identifier
    );
  }

  private isSignProcessValid(): boolean {
    return (
      this.signatures.filter((signature: SignatureResponse) => signature.signatureStatus !== SignatureValidationCode.OK)
        .length === 0
    );
  }

  private processSignatures(): void {
    this.signatures.forEach((signature: SignatureResponse) => {
      console.log(
        'Fichero ' + signature.request.file.name + ' firmado correctamente'
      );
      this.oe_files = this.oe_files.map((originalFile: FileDetailsDTO) => {
        return originalFile.identifier === signature.request.file.identifier
          ? signature.file
          : originalFile;
      });
    });
    this.currentFile = this.oe_files[0];
  }

  signLink(): boolean {
    return this.isSignActionAvailable;
  }

  rejectLink(): boolean {
    return this.isRejectActionAvailable;
  }

  toPlainList(treeList) {
    this.toPlainListRecursive(treeList);
    console.log(this.signaturesPlainList);

    this.signaturesPlainList.sort((a, b) =>
      a['date'] < b['date']
        ? -1
        : a['date'] > b['date']
          ? 1
          : 0
    );

  }

  toPlainListRecursive(treeList) {
    // this.signaturesPlainList = [];
    if (treeList && treeList.length > 0) {
      treeList.forEach((item: any) => {
        console.log('Firma ' + item.signer);

        this.signaturesPlainList.push(item);
        this.toPlainListRecursive(item.signatures);
      });

    }
  }

  public getProcedureIdentifier(identifier: DocumentVersionIdDTO): string {
    return getSimpleIdentifier(identifier);
  }

  selectComment(comment: SignatureCommentDTO) {
    console.log('COMENTARIO DE FIRMA SELECCIONADO:', comment);
    this.comment = comment.comment;
  }

  createActions() {

    // Si no es pantalla modal (windowHash)
    // o si es una tarea abierta en modal (modalWindowHash)
    if (!this.windowHash || this.modalWindowHash) {

      this.headerService.clearWindowActions(this.windowHash);

      // Establecemos cabecera y botones de accion
      if (!this.isSigningCall()) {
        // Si no es una tarea de firma
        this.headerService.setProject(
          this.elem,
          this.document.entity.division.project,
          true
        );

        this.headerService.setTaskDescription(
          this.elem,
          this.document.name,
          'fa-eye',
          true
        );

      }

      this.subscribe(this.headerService
        .addWindowAction(
          'DocumentView.refuse',
          'fa fa-1-25x fa-mail-reply',
          'btn-warning  show-text-onxs',
          () => this.isSigningCall() && this.rejectLink(),
          this.windowHash
        ), (success) => {
          this.rejectDocument();
        });

      // firma con los distintos proveedores de seguridad registrados
      if (this.enabledSignatureProviders.length > 1) {
        this.headerService.addActionGroup(
          'signature.actions',
          'DocumentView.sign',
          'fa fa-file-signature',
          'btn-primary',
          true
        );
        this.enabledSignatureProviders.forEach((provider: SignatureProvider) => {
          this.subscribe(this.headerService.addActionToGroup(
            'signature.actions',
            provider.config?.btnName,
            provider.config?.btnIcon,
            provider.config?.btnClass,
            () => this.isSigningCall() && this.signLink(),
            this.windowHash,
            () => this.signModuleAvailable(provider.type),
            'Signature.AutoFirma.ModuleNotLoaded'
          ).pipe(
            tap(() => this.signDocument(provider.type))
          ));
        });
      } else if (this.enabledSignatureProviders.length === 1) {
        const provider = this.enabledSignatureProviders[0];
        this.subscribe(this.headerService.addWindowAction(
          'DocumentView.sign',
          provider.config?.btnIcon,
          provider.config?.btnClass,
          () => this.isSigningCall() && this.signLink(),
          this.windowHash,
          () => this.signModuleAvailable(provider.type),
          'Signature.AutoFirma.ModuleNotLoaded'
        ).pipe(
          tap(() => this.signDocument(provider.type))
        ));
      }

      if (!this.modalWindowHash) {
        this.headerService.addWindowDivider(this.windowHash);
        this.subscribe(this.headerService
          .addWindowAction(
            'General.back',
            'fas fa-chevron-left',
            'btn-outline-secondary',
            true,
            this.windowHash
          ), (success) => {
            this.uiService.routeBack();
          });
      }
      if (this.dialogConfig && this.dialogConfig.data) {
        this.headerService.addWindowDivider(this.windowHash);
        this.subscribe(this.headerService.addWindowAction(
          'General.close',
          'fas fa-times',
          'btn-outline-secondary',
          true,
          this.windowHash
        ), () => {
          this.subscribe(this.taskService.unlockTask(this.task),
            () => {
              this.waitService.cancelWaiting();
              this.dialogRef.close();
            },
            (error: any) => {
              console.error(error);
              this.dialogRef.close();
            });
        });
      }
    } else {
      // Es una consulta de documento en dialogo
      this.headerService.clearWindowActions(this.windowHash);
      this.subscribe(this.headerService.addWindowAction(
        'General.close',
        'fas fa-times',
        'btn-outline-secondary',
        true,
        this.windowHash
      ), () => {
        this.dialogRef.close();
      });
    }
  }

  public nextDocument(): void {
    this.waitService.startWaiting();
    this.documentIndex++;
    this.initFileInterface();
    this.loadTaskDocument();
  }

  public previousDocument(): void {
    this.waitService.startWaiting();
    this.documentIndex--;
    this.initFileInterface();
    this.loadTaskDocument();
  }

  private initFileInterface() {
    this.signatures = new Array<SignatureResponse>();
    this.currentFile = null;
    this.ca_files = null;
    this.oe_files = null;
    this.sys_files = null;
    this.usr_files = null;
  }

  private loadTaskDocument(autoDispatch = false): void {
    console.log('loadTaskDocument...');
    this.document = this.task.work.documents[this.documentIndex];
    this.documentId = this.task.work?.documents[this.documentIndex]?.identifier;
    this.isSignActionAvailable = this.documentHasAction(this.task.work?.documents[this.documentIndex], ActionTypeDTO.DOCUMENT_SIGN);
    this.isRejectActionAvailable = this.documentHasAction(this.task.work?.documents[this.documentIndex], ActionTypeDTO.DOCUMENT_REJECT);

    if (!this.document) {
      this.uiService.showMessage(this.translate.instant('DocumentView.error.NoDocument'), this.translate.instant('General.error'));
    } else if (this.isTaskReloadRequired()) {
      if (
        this.numberOfTaskDetailInvocation < MAX_TASKDETAIL_RETRIES &&
        !this.retrySubscription
      ) {
        this.waitService.setLoadingInfo(
          new LoadingInfo(
            true,
            this.translateService.instant('DocumentView.wait.oe'),
            true
          )
        );
        console.error(
          'La tarea no tiene acciones, consultado estado en ' +
          TASKDETAIL_RETRY_INTERVAL / 1000 +
          ' seg...'
        );
        this.unregisterSubscription(this.retrySubscription);
        this.retrySubscription = this.retryObservable.subscribe();
        this.registerSubscription(this.retrySubscription);

      } else if (
        this.numberOfTaskDetailInvocation >= MAX_TASKDETAIL_RETRIES
      ) {
        this.stopRetrySubscription();
      }
    } else {
      this.loadDocument();
      if (autoDispatch && this.task.work.state === WorkStateTypeDTO.COMPLETED) {
        // despachar tarea
        this.subscribe(this.uiService.showMessage(this.translateService.instant('DocumentView.autoDispatch'),
          undefined,
          undefined,
          'General.accept')
          .onClose, () => this.dispatch());
      }
    }
  }

  public getPendigSignatureDocs(): number {
    return (this.task?.work?.documents) ? this.task.work.documents
      .filter(doc => this.documentHasAction(doc, ActionTypeDTO.DOCUMENT_SIGN)
        || this.documentHasAction(doc, ActionTypeDTO.DOCUMENT_REJECT)).length : 0;
  }

  public searchDocuments(): void {
    let config: DynamicDialogConfig = {
      header: '',
      width: '80%',
      styleClass: 'helpStyle'
    };
    config['documentId'] = this.document.identifier;

    // establecer filtros
    let docQueryFilter = {
      avoidTemporaryDocs: true
    }
    config['docFilters'] = docQueryFilter;
    config['selectionMode'] = true;

    let ref = this.dialogService.open(documentsComponent, config);
    this.subscribe(ref.onClose,
      (documentresult: DocumentDTO) => {

      },
      (error) => {

        throw error;
      }
    );
  }



}
